module.exports = new __parcel__URL__("screenshot.6661b14d.png").toString();